import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ikonIndikator } from "../../utils/indicatorIcon";
import React from "react";
import { Badge } from "react-bootstrap";
import moment from "moment";

const STATUS = [
  { id: "", name: "Semua Status" },
  { id: "draft", name: "Draft" },
  { id: "active", name: "Aktif" },
  { id: "archived", name: "Arsip" },
];

const KATEGORI = [
  { id: "", name: "Semua Kategori" },
  { id: "environment", name: "Lingkungan" },
  { id: "social", name: "Sosial" },
  { id: "efficiency", name: "Efisiensi" },
];

const warnaStatus = (status) =>
  status === "active" ? "success" : status === "draft" ? "warning" : "dark";

function TabRegistry({
  list,
  status,
  kategori,
  onChangeStatus,
  onChangeKategori,
  onTambah,
  onEdit,
  onValidasi,
  onDryRun,
  onPublish,
  onArchive,
}) {
  return (
    <div>
      <div className="d-flex flex-wrap justify-content-between align-items-center mb-2">
        <div className="d-flex" style={{ fontSize: "12px" }}>
          <select
            className="form-select form-select-sm me-2"
            style={{ width: 160, fontSize: "12px" }}
            value={status}
            onChange={(e) => onChangeStatus(e.target.value)}
          >
            {STATUS.map((val) => (
              <option key={val.id} value={val.id}>
                {val.name}
              </option>
            ))}
          </select>
          <select
            className="form-select form-select-sm"
            style={{ width: 160, fontSize: "12px" }}
            value={kategori}
            onChange={(e) => onChangeKategori(e.target.value)}
          >
            {KATEGORI.map((val) => (
              <option key={val.id} value={val.id}>
                {val.name}
              </option>
            ))}
          </select>
        </div>
        <button className="btn btn-sm btn-primary" onClick={onTambah}>
          Tambah Indikator
        </button>
      </div>

      <div className="table-responsive">
        <table
          className="table table-bordered align-middle mb-0"
          style={{ fontSize: "12px" }}
        >
          <thead className="table-light">
            <tr>
              <th>Kode / Nama</th>
              <th>Kategori</th>
              <th>Unit</th>
              <th>Perhitungan</th>
              <th className="text-center">Hemat</th>
              <th className="text-center">Tier Min.</th>
              <th className="text-center">Versi</th>
              <th className="text-center">Status</th>
              <th>Berlaku</th>
              <th className="text-center">Aksi</th>
            </tr>
          </thead>
          <tbody>
            {list && list.length > 0 ? (
              list.map((val) => (
                <tr key={val.id}>
                  <td>
                    <div className="fw-bold">
                      <FontAwesomeIcon
                      icon={ikonIndikator(val.icon)}
                      className="me-2 text-secondary"
                    />
                      {val.name_id}
                    </div>
                    <div className="text-muted" style={{ fontSize: "10px" }}>
                      {val.code}
                    </div>
                  </td>
                  <td>{val.kategori}</td>
                  <td>{val.unit}</td>
                  <td>
                    {val.calculation_type}
                    {val.calculation_type === "derived" && (
                      <div
                        className="text-muted ws-preline"
                        style={{ fontSize: "10px" }}
                      >
                        {val.formula_expression}
                      </div>
                    )}
                  </td>
                  <td className="text-center">
                    {val.has_saving ? (
                      <Badge bg="info">
                        {val.baseline ? val.baseline.baseline_type : "tanpa baseline"}
                      </Badge>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td className="text-center">
                    <Badge bg="secondary">{val.min_quality_tier_to_publish}</Badge>
                  </td>
                  <td className="text-center">v{val.version}</td>
                  <td className="text-center">
                    <Badge bg={warnaStatus(val.status)}>{val.status}</Badge>
                  </td>
                  <td>
                    {val.effective_from
                      ? moment(val.effective_from).format("DD MMM YYYY")
                      : "-"}
                  </td>
                  <td>
                    <div className="d-flex flex-column">
                      <button
                        className="btn btn-sm btn-outline-secondary mb-1"
                        style={{ fontSize: "10px" }}
                        onClick={() => onEdit(val)}
                      >
                        {val.status === "draft" ? "Ubah" : "Lihat"}
                      </button>
                      <button
                        className="btn btn-sm btn-outline-primary mb-1"
                        style={{ fontSize: "10px" }}
                        onClick={() => onValidasi(val)}
                      >
                        Validasi
                      </button>
                      <button
                        className="btn btn-sm btn-outline-warning mb-1"
                        style={{ fontSize: "10px" }}
                        onClick={() => onDryRun(val)}
                      >
                        Dry-run
                      </button>
                      {val.status === "draft" && (
                        <button
                          className="btn btn-sm btn-outline-success mb-1"
                          style={{ fontSize: "10px" }}
                          onClick={() => onPublish(val)}
                        >
                          Publish
                        </button>
                      )}
                      {val.status !== "archived" && (
                        <button
                          className="btn btn-sm btn-outline-dark"
                          style={{ fontSize: "10px" }}
                          onClick={() => onArchive(val)}
                        >
                          Archive
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={10} align="center">
                  Data tidak ditemukan
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TabRegistry;
